import axios from "axios"
const URL = process.env.REACT_APP_MASTER_URL


export async function getOrderBookingData() {
  console.log("inside OrderBooking")
  const url = `${URL}/enquiry/sharepointlist/getOrderBookingData`;
  console.log("inside getOrderBookingData", url)
  let response = await axios.get(url);
  console.log("inside inside getOrderBookingData", response.data)
  return response.data;
}

export async function getOrderBookingDataById(order) {
  console.log("inside OrderBooking")
  const url = `${URL}/enquiry/sharepointlist/getOrderBookingDataById`;
  console.log("inside getOrderBookingDataById", url)
  let response = await axios.post(url, order);
  console.log("inside inside getOrderBookingDataById", response.data)
  return response.data;
}

export async function getOBKitAttachmentData(order) {
  console.log("inside OrderBooking")
  const url = `${URL}/enquiry/sharepointlist/getOBKitAttachmentData`;
  console.log("inside getOBKitAttachmentData", url)
  let response = await axios.post(url, order);
  console.log("inside inside getOBKitAttachmentData", response.data)
  return response.data;
}

export async function getOBAmendmentData(order) {
  console.log("inside OrderBooking")
  const url = `${URL}/enquiry/sharepointlist/getOBAmendmentData`;
  console.log("inside getOBAmendmentData", url)
  let response = await axios.post(url, order);
  console.log("inside inside getOBAmendmentData", response.data)
  return response.data;
}

export async function addOrderBookingData(payload) {
  console.log("payload in order booking",payload)
  const url = `${URL}/enquiry/sharepointlist/addOrderBooking`;
  let response = await axios.post(url, payload);
  console.log("response from addOB", response.data)
  return response.data;
}

export async function addOBKitAttachmentData(formDataPayload) {
  const url = `${URL}/enquiry/sharepointlist/addOBKitAttachmentData`;
  let response = await axios.post(url, formDataPayload, { headers: { "Content-Type": "multipart/form-data" } });
  return response.data;
}

export async function addOBAmendmentData(payload) {
  const url = `${URL}/enquiry/sharepointlist/addOBAmendmentData`;
  let response = await axios.post(url, payload);
  return response.data;
}

export async function updateOrderBookingData(payload) {
  const url = `${URL}/enquiry/sharepointlist/update/orderBooking`;
  let response = await axios.post(url, payload);
  return response.data;
}

// ISOB APIs
export async function addIsobData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addIsob`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobData:', error);
    throw error;
  }
}

export async function addIsobBpData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addIsobBp`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobBpData:', error);
    throw error;
  }
}

export async function addIsobCompData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addIsobPgComp`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobCompData:', error);
    throw error;
  }
}

export async function addIsobDwgData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addisobDwg`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobDwgData:', error);
    throw error;
  }
}

export async function updateIsob(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/update/isob`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in updateIsob:', error);
    throw error;
  }
}

export async function addIsobPgCommercialData(data) {
console.log("pgcommercial")
  try {
    const url = `${URL}/enquiry/sharepointlist/addisobPgCommercial`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobPgCommercialData:', error);
    throw error;
  }
}

// export async function addIsobCommercialData(data) {
//   try {
//     const url = `${URL}/enquiry/sharepointlist/addisobPgCommercial`;
//     const response = await axios.post(url, data);
//     return response.data;
//   } catch (error) {
//     console.error('Error in addIsobCommercialData:', error);
//     throw error;
//   }
// }

export async function addIsobLdData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addisobLd`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobLdData:', error);
    throw error;
  }
}

export async function addIsobAdvanceData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addIsobAdvance`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobAdvanceData:', error);
    throw error;
  }
}

export async function addIsobDealerSacData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addisobDealerSac`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobDealerSacData:', error);
    throw error;
  }
}

export async function addIsobMiscData(data) {
  try {
    const url = `${URL}/enquiry/sharepointlist/addIsobMisc`;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in addIsobMiscData:', error);
    throw error;
  }
}

// Delete APIs for rollback - Using existing deleteItem functions
export async function rollbackOrderBooking(id) {
  try {
    const url = `${URL}/enquiry/sharepointlist/rollbackOrderBooking/${id}`;
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.error('Error in rollbackOrderBooking:', error);
    throw error;
  }
}

export async function rollbackIsobData(type,id) {
  try {
    const url = `${URL}/enquiry/sharepointlist/rollbackIsobData/${type}/${id}`;
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.error('Error in rollbackIsobData:', error);
    throw error;
  }
}

export async function downloadOrderBookingPdf(payload) {
  const url = `${URL}/enquiry/sharepointlist/generateOrderBookingPdf`;
  const response = await axios.post(url, payload);
  console.log("resposnse of downloadorderbooking",response);
  return response.data.data;
}


